import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

export const GooglePayButton = ({ config, instance }) => {
  const { expressCheckout = {} } = config || {};
  const { appearance = {} } = expressCheckout;
  const buttonInitialized = useRef(false);

  useEffect(() => {
    // Ensure button is only created once per instance
    if (!buttonInitialized.current && instance) {
      instance.createButton();
      buttonInitialized.current = true;
    }
  }, [instance]);

  return (
    <>
      <Helmet>
        <style type="text/css">{`
        #google-pay-button button {
          outline: transparent;
          min-width: 0;
        }
     `}</style>
      </Helmet>
      <div
        id="google-pay-button"
        style={{ height: appearance.buttonHeight || 44 }}
      ></div>
    </>
  );
};
